export default {
  "content": "<path fill=\"#B36800\" d=\"M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 5a1.25 1.25 0 110 2.5A1.25 1.25 0 0110 5zm1.563 10H8.437a.938.938 0 010-1.875h.626v-2.5H8.75a.938.938 0 010-1.875H10c.518 0 .938.42.938.938v3.437h.624a.938.938 0 010 1.875z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};